function setCookie(name, value, days) {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}
function getCookie(name) {
  const nameEQ = name + "=";
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}
function set_utm_param() {
	// Get UTM parameters
	const urlParams = new URLSearchParams(window.location.search);
	const utmContent = urlParams.get('utm_content');
	const utmSource = urlParams.get('utm_source');
	const utmMedium = urlParams.get('utm_medium');
	const utmCampaign = urlParams.get('utm_campaign');

	if (utmContent) setCookie('utm_content', utmContent, 7);
	if (utmSource) setCookie('utm_source', utmSource, 7);
	if (utmMedium) setCookie('utm_medium', utmMedium, 7);
	if (utmCampaign) setCookie('utm_campaign', utmCampaign, 7);
}

set_utm_param();